import { useMemo } from "react";

import usePolledQuery from "apollo/usePolledQuery";
import { PollingIntervalGroups } from "apollo/constants";

import { GET_LEAD_TIME_FOR_CHANGES_AVERAGE } from "./gql";

type UseGetLeadTimeForChangesAverageProps = {
  startTimeUnix: number;
  endTimeUnix: number;
};

const useGetLeadTimeForChangesAverage = ({
  startTimeUnix,
  endTimeUnix,
}: UseGetLeadTimeForChangesAverageProps) => {
  const { data, loading, error, refetch, networkStatus, previousData } = usePolledQuery(
    GET_LEAD_TIME_FOR_CHANGES_AVERAGE,
    {
      variables: { input: { startTime: startTimeUnix, endTime: endTimeUnix } },
      pollingGroup: PollingIntervalGroups.Dashboard,
    }
  );

  // Returns raw backend value in seconds, undefined when no data yet
  const averageSeconds = useMemo(() => {
    return (
      data?.metricsRange?.averageLeadTimeForChangesValue?.[0]?.value ??
      previousData?.metricsRange?.averageLeadTimeForChangesValue?.[0]?.value
    );
  }, [data, previousData]);

  return {
    averageSeconds,
    loading,
    error,
    refetch,
    networkStatus,
  };
};

export default useGetLeadTimeForChangesAverage;
